import React, { useRef } from 'react';
import PropTypes from 'prop-types';
import { useStatsigClient } from '@statsig/react-bindings';

// StatsigProvider swaps its children for loadingComponent whenever the client leaves
// the Ready state, which unmounts the whole app on every Statsig user update and
// re-runs every mount effect. Latching on the first ready keeps the placeholder to
// the initial load only.
const StatsigReadyLatch = ({ children }) => {
    const { client } = useStatsigClient();
    const hasBeenReady = useRef(false);

    if (client.loadingStatus === 'Ready' || 'isNoop' in client) {
        hasBeenReady.current = true;
    }

    if (!hasBeenReady.current) {
        return <div data-testid="app.statsig-loading" />;
    }

    return children;
};

StatsigReadyLatch.propTypes = {
    children: PropTypes.node.isRequired,
};

export default StatsigReadyLatch;
